<script setup lang="ts">
import { computed, onMounted, onBeforeUnmount, onActivated, onDeactivated } from 'vue'
import { useRouter } from 'vue-router'

const props = withDefaults(
  defineProps<{
    to: string
    external?: boolean
    class?: string
  }>(),
  {
    external: false,
    class: '',
  }
)

const router = useRouter()

const isExternal = computed(() => {
  if (!props.to) return false
  return props.external || String(props.to).startsWith('http') || String(props.to).startsWith('//')
})

const handleClick = (event: MouseEvent) => {
  if (!props.to) return

  // If it's an external link or Command/Ctrl is pressed, let the browser handle it
  if (isExternal.value || event.metaKey || event.ctrlKey) {
    return
  }

  // Otherwise prevent default and handle via router
  event.preventDefault()
  router.push(props.to)
}

// Properly handle lifecycle hooks within setup
onMounted(() => {
  // Component is mounted
})

onBeforeUnmount(() => {
  // Component will be unmounted
})

onActivated(() => {
  // Component is activated (when using keep-alive)
})

onDeactivated(() => {
  // Component is deactivated (when using keep-alive)
})
</script>

<template>
  <a
    v-bind="$attrs"
    :href="props.to"
    :target="isExternal ? '_blank' : undefined"
    :rel="isExternal ? 'noopener noreferrer' : undefined"
    :class="props.class"
    @click="handleClick"
  >
    <slot />
  </a>
</template>
